import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ProjectWorkflowFoundation"
    : "SLN/SolarentOperator/ProjectWorkflowFoundation";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectWorkflowFoundationApi = {
  getOperationalPlanByRequestId: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetOperationalPlanByRequestId?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess === true,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getOperationalPlanLookups: async (source) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetOperationalPlanLookups`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || {},
    };
  },

  getInitialSiteVisitPerformerLookups: async (source, performerType) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetInitialSiteVisitPerformerLookups?performerType=${encodeURIComponent(performerType)}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || {},
    };
  },

  upsertInitialSiteVisitAssignment: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/UpsertInitialSiteVisitAssignment`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  upsertOperationalPlan: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/UpsertOperationalPlan`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getAssignmentsByRequestId: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetAssignmentsByRequestId?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  createAssignment: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CreateAssignment`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getQuotesByRequestId: async (source, requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `${baseBySource(source)}/GetQuotesByRequestId?requestId=${requestId}`
      );
      if (!res) {
        return { ok: false, message: "پاسخ خالی از سرور", data: [] };
      }
      return {
        ok: res?.isSuccess !== false,
        message: res?.message || "",
        data: unwrapPayload(res) || [],
      };
    } catch (e) {
      return {
        ok: false,
        message:
          e?.response?.data?.message ||
          e?.message ||
          "خطا در دریافت پیشنهادهای قدیمی",
        data: [],
      };
    }
  },

  acceptQuote: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/AcceptQuote`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  rejectQuote: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/RejectQuote`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getQuoteEvents: async (source, quoteId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetQuoteEvents?quoteId=${quoteId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  addNegotiationMessage: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/AddNegotiationMessage`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  generateContractFromQuote: async (source, quoteId) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/GenerateContractFromQuote`,
      { quoteId }
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getNegotiationThread: async (source, quoteId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetNegotiationThread?quoteId=${quoteId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getContractAcceptanceAudit: async (source, projectContractId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetContractAcceptanceAudit?projectContractId=${projectContractId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getWorkflowV2StatusSummary: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetWorkflowV2StatusSummary?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getWorkflowV2StatusSummaries: async (source, requestIds) => {
    const ids = (Array.isArray(requestIds) ? requestIds : [])
      .filter(Boolean)
      .join(",");
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetWorkflowV2StatusSummaries?requestIds=${encodeURIComponent(ids)}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getWorkflowV2Timeline: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetWorkflowV2Timeline?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getWorkflowV2SiteVisitDetails: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetWorkflowV2SiteVisitDetails?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getProjectContractWorkspaceSummary: async (source, requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `${baseBySource(source)}/GetProjectContractWorkspaceSummary?requestId=${requestId}`
      );
      if (!res) {
        return { ok: false, message: "پاسخ خالی از سرور", data: null };
      }
      return {
        ok: res?.isSuccess !== false,
        message: res?.message || "",
        data: unwrapPayload(res),
      };
    } catch (e) {
      return {
        ok: false,
        message:
          e?.response?.data?.message ||
          e?.message ||
          "خطا در دریافت خلاصه قرارداد",
        data: null,
      };
    }
  },

  getProjectLoanGateStatus: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetProjectLoanGateStatus?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getProjectLoanMehrsanStageGateStatus: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetProjectLoanMehrsanStageGateStatus?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  getProjectFinancialExecutionGateStatus: async (source, requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetProjectFinancialExecutionGateStatus?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  approvePostDeliveryPaymentDeferral: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ApprovePostDeliveryPaymentDeferral`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  generateProjectContractFromCustomerOffer: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/GenerateProjectContractFromCustomerOffer`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  ensureEquipmentSnapshotFromApprovedPrice: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/EnsureEquipmentSnapshotFromApprovedPrice`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  terminateRequestDueToSiteVisitOutcome: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/TerminateRequestDueToSiteVisitOutcome`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },
};

export default ProjectWorkflowFoundationApi;
